export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-700 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4">
              <span className="text-2xl font-bold text-white">Karolay</span>
              <span className="text-sm text-white/70 block">Cleaning Services</span>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Professional home cleaning services you can trust. Making homes sparkle since 2008.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li>Regular House Cleaning</li>
              <li>Deep Cleaning</li>
              <li>Move In/Out Cleaning</li>
              <li>Office Cleaning</li>
              <li>Post-Construction</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-phone-line mr-2 mt-0.5 flex-shrink-0"></i>
                <a href="tel:+18603785186" className="text-white/80 hover:text-white transition-colors">
                  (860) 378-5186
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line mr-2 mt-0.5 flex-shrink-0"></i>
                <a href="mailto:karolay.ribeiro@hotmail.com" className="text-white/80 hover:text-white transition-colors break-all">
                  karolay.ribeiro@hotmail.com
                </a>
              </li>

            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-xs sm:text-sm text-white/70 text-center sm:text-left">
              © 2024 Home Cleaning Services. All rights reserved.
            </div>
            <div className="flex gap-3 sm:gap-4">
              <a href="https://www.instagram.com/karolay.cleaning/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}